import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Company Info (static - no API needed)
export const companyInfo = {
  name: "TaksiBond",
  phone: "+90 (530) 992 69 65",
  phoneClean: "+905309926965",
  plate: "HASTANE TAKSİ 20 T 0007",
  city: "Denizli",
  whatsappMessage: "Merhaba, taksi çağırmak istiyorum.",
  address: "Denizli Merkez",
  workingHours: "7/24 Hizmet"
};

// SEO Keywords (static)
export const seoKeywords = [
  "Denizli taksi",
  "Denizli 7/24 taksi",
  "Denizli havalimanı transfer",
  "Denizli Çardak havalimanı taksi",
  "Denizli şehirlerarası taksi",
  "Denizli VIP taksi",
  "Pamukkale taksi",
  "Denizli ucuz taksi",
  "Denizli güvenilir taksi",
  "Denizli hastane taksi",
  "TaksiBond Denizli"
];

// API Functions
export const api = {
  // Services
  getServices: async () => {
    try {
      const response = await axios.get(`${API}/services`);
      return response.data;
    } catch (error) {
      console.error('Error fetching services:', error);
      return [];
    }
  },

  // Prices
  getPrices: async () => {
    try {
      const response = await axios.get(`${API}/prices`);
      return response.data;
    } catch (error) {
      console.error('Error fetching prices:', error);
      return [];
    }
  },

  // Testimonials
  getTestimonials: async () => {
    try {
      const response = await axios.get(`${API}/testimonials`);
      return response.data;
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      return [];
    }
  },

  // FAQs
  getFaqs: async () => {
    try {
      const response = await axios.get(`${API}/faqs`);
      return response.data;
    } catch (error) {
      console.error('Error fetching faqs:', error);
      return [];
    }
  },

  // Bookings
  createBooking: async (bookingData) => {
    try {
      const response = await axios.post(`${API}/bookings`, bookingData);
      return response.data;
    } catch (error) {
      console.error('Error creating booking:', error);
      throw error;
    }
  },

  // Seed Database
  seedDatabase: async () => {
    try {
      const response = await axios.post(`${API}/seed`);
      return response.data;
    } catch (error) {
      console.error('Error seeding database:', error);
      throw error;
    }
  }
};

// Fallback data (used when API fails)
export const fallbackData = {
  services: [
    { id: "1", title: "Şehir İçi Taksi", description: "Denizli şehir içi tüm noktalara hızlı ve güvenli ulaşım.", icon: "car" },
    { id: "2", title: "Havalimanı Transfer", description: "Denizli Çardak Havalimanı transferleri.", icon: "plane" },
    { id: "3", title: "Şehirlerarası Yolculuk", description: "Denizli'den tüm illere şehirlerarası taksi hizmeti.", icon: "map" },
    { id: "4", title: "VIP Transfer", description: "Özel günleriniz için lüks araçlarla VIP transfer.", icon: "star" },
    { id: "5", title: "Pamukkale Turları", description: "Pamukkale gezileri için özel tur taksi hizmeti.", icon: "mountain" },
    { id: "6", title: "Hastane Transfer", description: "Hastanelere hasta transferi.", icon: "hospital" }
  ],
  prices: [
    { id: "1", from: "Denizli Devlet Hastanesi", to: "Otogar", price: "150 TL", duration: "5 dk" },
    { id: "2", from: "Merkez", to: "Çardak Havalimanı", price: "2500 TL", duration: "45 dk" },
    { id: "3", from: "Merkez", to: "Pamukkale", price: "1000 TL", duration: "30 dk" },
    { id: "4", from: "Denizli", to: "İzmir", price: "10000 TL", duration: "2.5 saat" }
  ],
  testimonials: [
    { id: "1", name: "Ahmet Y.", comment: "Havalimanı transferi için TaksiBond'u tercih ettim. Zamanında geldiler.", rating: 5 },
    { id: "2", name: "Fatma K.", comment: "Hastane randevularım için her zaman TaksiBond'u arıyorum.", rating: 5 },
    { id: "3", name: "Mehmet S.", comment: "Pamukkale turunda çok keyifli vakit geçirdik.", rating: 5 }
  ],
  faqs: [
    { id: "1", question: "TaksiBond 7/24 hizmet veriyor mu?", answer: "Evet, TaksiBond Denizli'de 7 gün 24 saat kesintisiz taksi hizmeti vermektedir." },
    { id: "2", question: "Havalimanı transfer ücreti ne kadar?", answer: "Denizli Çardak Havalimanı transfer ücreti mesafeye göre 450-550 TL arasında değişmektedir." },
    { id: "3", question: "Şehirlerarası yolculuk yapıyor musunuz?", answer: "Evet, Denizli'den İzmir, Antalya, Muğla, Aydın ve diğer illere şehirlerarası taksi hizmeti sunuyoruz." },
    { id: "4", question: "Ödeme nasıl yapılır?", answer: "Nakit ve kredi kartı ile ödeme kabul ediyoruz." },
    { id: "5", question: "Rezervasyon nasıl yapabilirim?", answer: "WhatsApp üzerinden veya telefonla arayarak kolayca rezervasyon yapabilirsiniz." }
  ]
};
